import * as React from 'react';
import { BREAKPOINTS } from '../consts/breakpoints';

/**
 * Hook to detect if the current viewport is mobile-sized
 * This is a modern replacement for src/components/hooks/useMobile.tsx
 *
 * @returns boolean indicating if viewport is mobile-sized (< 768px)
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(
    undefined,
  );

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${BREAKPOINTS.MOBILE - 1}px)`);

    const onChange = () => {
      setIsMobile(window.innerWidth < BREAKPOINTS.MOBILE);
    };

    mql.addEventListener('change', onChange);
    setIsMobile(window.innerWidth < BREAKPOINTS.MOBILE);

    return () => mql.removeEventListener('change', onChange);
  }, []);

  return !!isMobile;
}
